import PropTypes from 'prop-types';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

// Brand palette — synced from panel-ui (src/app/globals.css :root).
// Base = #5C55E5 (indigo). Keep the index → MUI-key mapping aligned with
// the rest of this file (e.g. `main` = 500-equivalent, `dark` = 700, etc.).
const brandPrimary = {
  0: '#F4F3FF', // primary-50  — "lighter"
  1: '#E6E5FD', // primary-100
  2: '#BAB7F7', // primary-200
  3: '#8E89F0', // primary-300 — "light"
  4: '#756FEB', // primary-400
  5: '#5C55E5', // primary-500 — "main"
  6: '#534CD7', // primary-600 — "dark"
  7: '#4A43C9', // primary-700
  8: '#3D37AC', // primary-800 — "darker"
  9: '#2F2A8F' // primary-900
};

const Default = (colors) => {
  const { cyan, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: brandPrimary[0],
      100: brandPrimary[1],
      200: brandPrimary[2],
      light: brandPrimary[3],
      400: brandPrimary[4],
      main: brandPrimary[5],
      dark: brandPrimary[6],
      700: brandPrimary[7],
      darker: brandPrimary[8],
      900: brandPrimary[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: '#FEF2F2',
      100: '#FEE2E2',
      light: '#FECACA',
      300: '#FCA5A5',
      400: '#F87171',
      main: '#EF4444',
      600: '#DC2626',
      dark: '#B91C1C',
      800: '#991B1B',
      darker: '#7F1D1D',
      contrastText
    },
    warning: {
      lighter: '#FFF7ED',
      100: '#FFEDD5',
      light: '#FED7AA',
      300: '#FDBA74',
      400: '#FB923C',
      main: '#F97316',
      600: '#EA580C',
      dark: '#C2410C',
      800: '#9A3412',
      darker: '#7C2D12',
      contrastText: greyColors[100]
    },
    info: {
      lighter: cyan[0],
      light: cyan[3],
      main: cyan[5],
      dark: cyan[7],
      darker: cyan[9],
      contrastText
    },
    success: {
      lighter: '#FFF7ED',
      100: '#D1FAE5',
      light: '#A7F3D0',
      300: '#6EE7B7',
      400: '#34D399',
      main: '#10B981',
      600: '#059669',
      dark: '#047857',
      800: '#065F46',
      darker: '#064E3B',
      contrastText
    },
    grey: greyColors
  };
};

Default.propTypes = {
  colors: PropTypes.object
};

export default Default;
